import { createActions } from 'redux-actions';

export const {
  corporateLeadCreate,
} = createActions(
  'CORPORATE_LEAD_CREATE',
  {
    prefix: 'CORPORATE_LEAD',
  },
);
